import React, { useEffect, useState } from "react";
import fetchProjectsFromAPI from './ProjectsData';

function Projects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const loadProjects = async () => {
      const fetchedProjects = await fetchProjectsFromAPI();
      setProjects(fetchedProjects);
    };

    loadProjects();
  }, []);

  return (
    <section id="projects">
      <div className="grid-container">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <a href={project.detailsLink} className="project-link">
              <img src={project.images[0]} alt={project.title} className="project-image" />
              <div className="overlay">
                <div className="project-info">
                  <h3>{project.title}</h3>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;
